import { render, staticRenderFns } from "./SystemSidoCode.vue?vue&type=template&id=0a850c46"
import script from "./SystemSidoCode.vue?vue&type=script&lang=js"
export * from "./SystemSidoCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports